<template>
    <div class="sustainable-component wage-block-dificulty-level-analysis">


        <!--<div class="bg-success mb-3 p-3 rounded">vue component wage-block-dificulty-level-analysis</div>-->


        <div class="container-fluid p-0">
            <div class="row">
                <div class="col-10 col-md-6">
                    <v-select bg-color="white" variant="outlined" v-bind:label="$t('general.workorganisation_general_position')" :items="internalModel.JobPositions" v-model="selectedPosition" item-title="Name" item-value="JobPositionId"></v-select>
                </div>
                <div class="col-2 col-md-6">
                    <v-checkbox Label="riktarbete" v-model="referencePosition"></v-checkbox>
                </div>
            </div>
            <div class="row">
                <div v-for="(item, i) in blockAnalysis.JobPositions" class="col col-md-4 mb-3" :key="i">
                    <div class="card" style="display:height:100%;">
                        <div class="card-body">
                            <h5 class="card-title">{{item.Name}}</h5>
                            <div class="card-text">
                                <table>
                                    <tr>
                                        <th class="col-3">Blocknr.</th>
                                        <th class="col-8">Blocknamn</th>
                                        <th class="col-1">Poäng</th>
                                    </tr>
                                    <tr v-for="(block, x) in item.Blocks" :key="x">
                                        <td>{{block.BlockNumber}}</td>
                                        <td>{{block.Name}}</td>
                                        <td>{{block.Points}}</td>
                                    </tr>
                                    <tr>
                                        <td class="pt-3"><b>Summa</b></td>
                                        <td></td>
                                        <td class="pt-3"><b>{{getSum(item.Blocks)}}</b></td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col col-md-4 mb-3">
                    <div class="card">
                        <div class="card-body">
                            <h5 class="card-title">Summa alla block</h5>
                            <div class="card-text">
                                <table>
                                    <tr>
                                        <th class="col-8">Befattning</th>
                                        <th class="col-4">Poäng</th>
                                    </tr>
                                    <tr v-for="(item, i) in blockAnalysis.BlockSumPoints" :key="i">
                                        <td>{{item.Name}}</td>
                                        <td>{{item.Points}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <v-btn v-bind:disabled="disabled" size="default" color="primary" class="btn-primary" @click="getAnalysis">
                        Uppdatera
                    </v-btn>
                </div>
            </div>

        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>

<script>

    //import WorkOrganisationService from "../../Services/WorkOrganisationService";
    //import WageService from "../../Services/WageService";
    import { getCurrentInstance } from 'vue'
    import WageService from '../../Services/WageService';
    import CommonSpinner from '../../common/common-spinner.vue'

    export default {
        emits: ['updated'],
        name: 'wage-block-dificulty-level-analysis',
        props: {
            model: Object,
            selectedJobPosition: String,
            disabled: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        components: {
            CommonSpinner,
        },
        methods: {
            getId() {
                return getCurrentInstance().uid;
            },
            async getAnalysis() {
                this.loading++;
                try {
                    this.blockAnalysis = await WageService.getBlockAnalysis(this.selectedPosition, this.referencePosition)
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            getSum(blocks) {
                var sum = 0;
                for (var i = 0; i < blocks.length; i++) {
                    sum += blocks[i].Points;
                }
                return sum;
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },
        data() {
            return {
                selectedPosition: null,
                referencePosition:null,
                internalModel: {
                    JobPositions: [],
                    BlockGrades: [],
                    WageFactorGrades: [],
                    WageFactors: [],
                },
                blockAnalysis: {},
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            selectedPosition: function (newVal) {
                this.getAnalysis();
                this.$emit('positionSelected', newVal)
            },
            referencePosition: function () {
                this.getAnalysis();
            },
        },
        mounted() {
            this.internalModel = this.model;
            this.selectedPosition = this.selectedJobPosition;
            if (this.internalModel.JobPositions.length > 0 && this.selectedJobPosition == null) {
                this.selectedPosition = this.internalModel.JobPositions[0].JobPositionId;
            }
        },

        // eslint-disable-next-line
        setup(props, { emit }) {}

    }
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    

</style>
